import React from "react";
import { connect } from "react-redux";
import { Button, Confirm } from "semantic-ui-react";
import "../CsaMedia/CsaMedia.css";

const ConfirmAdd = (props) => {
  return (
    <>
      <Confirm
        open={props.open}
        className="confirm-delete-popup initiate-modal"
        content={
          <div className="content">
            <div className="initiate-modal-content-1">
              Are you sure want to send reminder to{" "}
              {props.all ? "All" : props.length}{" "}
              {!props.advocates
                ? `Athlete${props.length < 2 ? "" : "s"}`
                : `Advocate${props.length < 2 ? "" : "s"}`}
            </div>
            <div className="initiate-modal-content-2">
              This process cannot be undone.
            </div>
          </div>
        }
        onCancel={() => {
          props.close();
        }}
        cancelButton="Cancel"
        confirmButton={
          <Button
            loading={props.adding}
            floated="right"
            name="saveButton"
            content="Save"
            labelPosition="right"
            icon="checkmark"
            onClick={() => {
              props.confirm();
              props.close();
            }}
          />
        }
      />
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    adding: state.reminder.adding,
    added: state.reminder.add,
  };
};

export default connect(mapStateToProps)(ConfirmAdd);
